import React from 'react'
import JsonView, { ReactJsonViewProps } from 'react-json-view'

import { useDarkMode } from '.'

const PrettyJson = <V extends object>({
  style,
  src,
  collapsed = true,
  onEdit,
  isDelete = false,
}: {
  collapsed?: boolean | number
  style?: ReactJsonViewProps['style']
  src: V | undefined
  onEdit?(updateSrc: V): void
  isDelete?: boolean
}) => {
  const [darkMode] = useDarkMode()
  if (!src) {
    return null
  }
  return (
    <div
      onClick={(e) => {
        // We don't have access to the click handler events in JsonView
        e.stopPropagation()
      }}
    >
      <JsonView
        style={style}
        name={false}
        collapsed={collapsed}
        theme={darkMode ? 'bright' : 'shapeshifter:inverted'}
        indentWidth={2}
        enableClipboard={true}
        shouldCollapse={false}
        displayObjectSize={false}
        displayDataTypes={false}
        onEdit={onEdit ? (v) => onEdit(v.updated_src as V) : undefined}
        onDelete={onEdit && isDelete ? (v) => onEdit(v.updated_src as V) : undefined}
        onAdd={onEdit ? (v) => onEdit(v.updated_src as V) : undefined}
        src={src}
      />
    </div>
  )
}

export default PrettyJson
